export default __webpack_public_path__ + "static/media/main-logo.c65cf181.svg";